import {Component} from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['footer.component.css'],
  moduleId: module.id
})

export class FooterComponent {

}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/footer/footer.component.ts